import type { FC } from 'react';

import { useContent } from '@eneco/cms';
import { Script } from '@eneco/next';

import type { FlourishChartContent } from './flourish-chart-content.types';

/**
 * `FlourishChart` block for the CMS-agnostic lane, serving **both** providers. Mirrors the legacy
 * component (`libs/sitecore/components/content/src/FlourishChart/FlourishChart.tsx`): an embed div for
 * the given Flourish visualization id, plus the (idempotent, shared across every instance) embed script.
 */
const FlourishChart: FC = () => {
  const content = useContent<FlourishChartContent>();
  const id = content.visualizationId;

  if (!id) return null;

  return (
    <div className="flourish-embed flourish-chart" data-src={`visualisation/${id}`}>
      <Script strategy="afterInteractive" id="flourish" src="https://public.flourish.studio/resources/embed.js" />
    </div>
  );
};

export default FlourishChart;
